import { ACC_SCHEDULE_SEATS, UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId, AcceleratorWithAvailableSeats } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<AcceleratorWithAvailableSeats, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId),
		buildColumn(util, 'FullName', row => row.name, { header: 'Accelerator' }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.facilitatorStaffId), { header: 'Program Facilitator Name' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language' }),
		buildColumn(util, 'Number', row => row.availableSeats, { header: 'Available Seats' }),
		buildColumn(util, 'Number', row => row.seatsOffered, { header: 'Offered Seats' }),
		buildColumn(util, 'Number', row => row.seatsAccepted, { header: 'Accepted Seats' }),
		buildColumn(util, 'Text', row => row.meetingLocalDisplayText, { header: 'Meeting Time (local time)', headerTooltip: 'Time is shown in the time zone of your current location' }),
		buildColumn(util, 'Text', row => row.meetingAcceleratorDisplayText, { header: 'Meeting Time (accelerator time)', headerTooltip: 'Time is shown in the time zone of the accelerator', hidden: true }),
		buildColumn(util, 'Text', row => row.gravityLocation, { header: 'Gravity Location' }),
		buildColumn(util, 'Text', row => row.gravityZip.toString().padStart(5, '0'), { header: 'Gravity Zip' }),
		buildColumn(util, 'YesNo', row => row.canceled, { header: 'Canceled', hidden: true }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}